import React from 'react';
import Styles from '../Styles';
import {StyleSheet, StyleProp, TextStyle, ViewStyle} from 'react-native';
import {Searchbar} from 'react-native-paper';
import Settings from 'src/Settings';
import {BuildTypeEnum} from 'src/constants/BuildTypeEnum';
import {getLayoutDescriber} from 'src/components/elements/layoutDescriptor/DescriptorType';

type SearchbarProps = React.ComponentProps<typeof Searchbar> & {
  placeholder: string;
  value: string;
  containerStyle?: StyleProp<ViewStyle>;
  searchTextStyle?: StyleProp<TextStyle>;
  onChangeText?: (text: string) => void;
  accessibilityLabel?: string;
  searchIcon?: React.ReactNode;
  elevation?: number;
  removeShadow?: boolean;
  testID?: string;
};

const CustomSearchbar = (props: SearchbarProps) => {
  const getFont = (): StyleProp<TextStyle> => {

    //TODO:SM: need refactor
    if (Settings.buildType === BuildTypeEnum.default) {
      return {
        fontFamily: Styles.FontFamily.aeonikRegular,
        fontSize: getLayoutDescriber().subHeaderFontSize(),
        fontWeight: '400',
        color: Styles.black,
        marginTop: -4,
        marginLeft: -10,
      };
    } else if (Settings.buildType === BuildTypeEnum.refive) {
      return {
        fontFamily: Styles.FontFamily.figtreeRegular,
        fontSize: getLayoutDescriber().subHeaderFontSize(),
        fontWeight: '400',
        color: Styles.black,
        marginTop: -2,
        marginLeft: -10,
      };
    } else {
      return {
        fontFamily: Styles.FontFamily.figtreeRegular,
        fontSize: getLayoutDescriber().subHeaderFontSize(),
        fontWeight: '400',
        color: Styles.black,
        marginTop: -2,
        marginLeft: -10,
        height: 42,
      };
    }
  };

  const getStyle = (): StyleProp<ViewStyle> => {
    const searchFieldHeight = props.containerStyle?.['height'] ?? 52;
    if (Settings.buildType === BuildTypeEnum.default) {
      return {
        height: searchFieldHeight,
        borderRadius: Styles.Spacing.m4,
        backgroundColor: Styles.Colors.PayNew.white01,
        borderWidth: 1,
        overflow: 'hidden',
      };
    } else {
      return null;
    }
  };

  return (
    <Searchbar
      placeholder={props.placeholder}
      placeholderTextColor={Styles.Colors.PayNew.darkHuesBase04}
      onChangeText={props.onChangeText}
      value={props.value}
      style={[
        styles.defaultContainerStyle,
        !props.removeShadow && getLayoutDescriber().shadowStyles().lightShadow,
        props.containerStyle,
        getStyle(),
      ]}
      inputStyle={[getFont(), props.searchTextStyle]}
      iconColor={Styles.Colors.PayNew.darkHuesBase04}
      accessibilityLabel={props.accessibilityLabel ?? props.placeholder}
      maxFontSizeMultiplier={
        props.maxFontSizeMultiplier ?? Styles.FontSizeMultiplier.maxfm6
      }
      icon={props.searchIcon ? () => props.searchIcon : null}
      elevation={props.elevation}
      testID={props.testID}
    />
  );
};

const styles = StyleSheet.create({
  defaultContainerStyle: {
    borderWidth: 1,
    borderColor: Styles.Colors.PayNew.neutralHuesBase09,
    backgroundColor: Styles.white,
  },
});
export default CustomSearchbar;
